import {
  TOrderSettingsTabKey,
} from '@/page/orders/order-settings.ts';

const tabs: Record<TOrderSettingsTabKey, string> = {
  attributes: 'Attribute',
  tableView: 'Übersichtstabelle',
};
export default {
  tabs,
};
